(function(w,factory){if(typeof module==='object'&&module.exports)module.exports=factory;else w.COVWCamera=factory(w);})(typeof window!=='undefined'?window:globalThis,function(w){
  'use strict';
  const normalize=value=>String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');
  const models=new Set(['golf','golfsportsvan','golfspotsvan','passat','troc','tcross','scirocco','tiguan']);
  function matches(car){return !!car&&['volkswagen','vw'].includes(normalize(car.brandId||car.brand))&&models.has(normalize(car.model));}
  function active(){return w.COShopifyBridge?.finderSelectedCar?.()||null;}
  function render(){return w.document.getElementById('co-vw-camera-template')?.innerHTML||'';}
  let cleanup=null,host=null;
  function mount(){
    const next=w.document.querySelector('#main [data-vwc-loop]');if(next===host)return;
    cleanup?.();cleanup=null;host=next;if(!host)return;
    const el=host,base=el.querySelector('img'),overlay=el.querySelector('[data-vwc-carplay]');
    const media=w.matchMedia('(prefers-reduced-motion: reduce)'),preload=new w.Image();
    let ready=false,visible=false,disposed=false;
    function sync(){
      el.toggleAttribute('data-vwc-playing',ready&&visible&&!media.matches&&!w.document.hidden);
    }
    function loaded(){if(disposed||!base.complete||!base.naturalWidth||!preload.complete||!preload.naturalWidth)return;ready=true;el.setAttribute('data-vwc-ready','');sync();}
    const observer=new w.IntersectionObserver(entries=>{visible=entries.some(entry=>entry.isIntersecting);sync();},{threshold:0.15});observer.observe(el);
    base.addEventListener('load',loaded);preload.addEventListener('load',loaded);
    media.addEventListener('change',sync);w.document.addEventListener('visibilitychange',sync);
    preload.src=overlay.getAttribute('src');loaded();
    cleanup=()=>{disposed=true;observer.disconnect();base.removeEventListener('load',loaded);preload.removeEventListener('load',loaded);media.removeEventListener('change',sync);w.document.removeEventListener('visibilitychange',sync);el.removeAttribute('data-vwc-playing');};
  }
  return {matches,active,render,mount};
});
